import { MatButtonModule, MatCheckboxModule, MatSlideToggleModule, MatCardModule, MatTabsModule, MatTableModule, MatPaginatorModule, MatIconModule, MatChipsModule } from '@angular/material';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [MatButtonModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatIconModule, MatPaginatorModule, MatSlideToggleModule, MatTableModule, MatTabsModule],
    exports: [MatButtonModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatIconModule, MatPaginatorModule, MatSlideToggleModule, MatTableModule, MatTabsModule],
})
export class AngularMaterialModule { }


// WEBPACK FOOTER //
// ./src/app/app.material-module.ts